import { Types } from "@grandvisionhq/auth";
const isProfileForm = (formName) => {
  if (typeof formName === "string") {
    return formName in Types.FormName;
  }
  return formName.formName in Types.FormName;
};
export {
  isProfileForm
};
//# sourceMappingURL=state.js.map
